<template>
	<div class='window white'>

	    <swap v-if='!swapbtc || (swapbtc && !loaded)'></swap>
    </div>
</template>

<script>
    import { getters, contract as currentContract, gas as contractGas} from '../../contract'
    import * as shiftState from '../ren/shiftState'
	import Swap from './Swap.vue'
    import config from '@/constants/config'
    import { getTokenIcon } from '@/utils/helpers'

	import LoadingComponent from '../ren/LoadingComponent.vue'
    const SwapNative = () => ({
        component: import('../ren/Gateway.vue'),

        loading: Swap,

        delay: 0,
    })

	export default {
		components: {
			Swap,
			SwapNative,
		},


		data: () => ({
			loading: false,
            config,
		}),

		created() {
			if(this.$route.path.includes('native')) this.swapbtc = true
			if(this.$route.path.includes('recover')) shiftState.state.recover = true
			this.$watch(() => currentContract.currentContract, (val, oldval) => {
				if(['ren', 'sbtc'].includes(oldval) && !['ren', 'sbtc'].includes(val)) this.swapbtc = false
			}, {
				immediate: true,
			})
		},

		watch: {
			swapbtc(val) {
				if(val) this.loading = true
				else this.loading = false
			}
		},

		computed: {
			swapComponent() {
				console.log(currentContract.currentContract, "CURRENT CONTRACT")
				if(this.swapbtc && ['ren', 'sbtc'].includes(currentContract.currentContract)) return 'SwapNative'
				return 'Swap'
			},
			currentPool() {
				return getters.currentPool()
			},
			hasIncomplete() {
				return shiftState.hasIncomplete()
			},
			swapbtc: {
				get() {
					return currentContract.swapbtc && ['ren', 'sbtc'].includes(currentContract.currentContract)
				},
				set(val) {
					currentContract.swapbtc = val
				},
			},
			publicPath() {
                return process.env.BASE_URL
            },
            default_account() {
            	return getters.default_account()
            },
            contactUs() {
            	return ['0x0f87dd03a74e6a48d56661d96f44880c79b9d795'].map(a => a.toLowerCase())
            		.includes(this.default_account.toLowerCase())
            },
		},

		methods: {
			loaded() {
				if(this.swapComponent == 'SwapNative') this.loading = false;
			},
            getTokenIcon,
		},

	}
</script>

<style scoped>
	.swapBTC-container {
		margin-top: 1em;
		margin-bottom: 1em;
		cursor: pointer;
	}
	.swapBTC-container label {
		cursor: pointer;
	}
	.loading.line {
		margin-left: 1em;
	}
	.aligncontainer {
		margin: 0 auto;
		width: 80%;
	}
	.swapBTC-container.info-message {
		padding-top: 0.4em;
		padding-bottom: 0.4em;
	}
</style>
